const normalizeTarget = target => {
  if (target === 'document') return document;
  if (target === 'window') return window;
  return target || document;
};

export default normalizeTarget;
